import {
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useLocalization } from '@ui-framework/index';
import { IconLibrary } from '@product-framework/index';
import CategoryBanner from './CategoryBanner';

// Reader card: banner with the title, a short description, and what the
// document offers. No version or admin details.
export default function HelpDocumentCard({ document, onClick }) {
  const { formatMessage } = useLocalization();
  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2,
        transition: 'box-shadow 150ms ease, transform 150ms ease',
        '&:hover': { boxShadow: 4, transform: 'translateY(-2px)' },
      }}>
      <CardActionArea
        onClick={() => onClick(document)}
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        }}>
        <CategoryBanner
          category={document.category}
          thumbnailUrl={document.thumbnailUrl}
          title={document.title}
          height={112}
        />
        <CardContent
          sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          {document.description && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}>
              {document.description}
            </Typography>
          )}
          <Stack
            direction="row"
            spacing={0.75}
            useFlexGap
            flexWrap="wrap"
            sx={{ mt: 'auto', pt: 1.5 }}>
            {document.hasPdf && (
              <Chip
                size="small"
                variant="outlined"
                icon={<IconLibrary.Note fontSize="small" />}
                label={formatMessage({
                  id: 'GUIDE',
                  defaultMessage: 'Guide',
                })}
              />
            )}
            {document.hasVideo && (
              <Chip
                size="small"
                variant="outlined"
                icon={<IconLibrary.ISSUE_STATUS_IN_PROGRESS fontSize="small" />}
                label={formatMessage({
                  id: 'VIDEO',
                  defaultMessage: 'Video',
                })}
              />
            )}
            {document.usedFallbackLanguage && (
              <Tooltip
                title={formatMessage(
                  {
                    id: 'HELP_CARD_LANGUAGE_FALLBACK',
                    defaultMessage:
                      'Shown in {language} because your language is not available.',
                  },
                  { language: String(document.languageCode).toUpperCase() },
                )}>
                <Chip
                  size="small"
                  variant="outlined"
                  icon={<IconLibrary.Public fontSize="small" />}
                  label={String(document.languageCode).toUpperCase()}
                />
              </Tooltip>
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
